export const NUCLEUS_ADMIN = 100000085;

export const hasAdviser = adviser => adviser && adviser.adviserId !== NUCLEUS_ADMIN;

export class LiveSupport {
    getChatButton = () => {
        const buttons = window.document.querySelectorAll(".pzl_interaction-wrapper button");
        return buttons[buttons.length - 1];
    };
    open = () => {
        const chatButton = this.getChatButton();

        if (chatButton) {
            chatButton.click();
        }
    };
}
